import { useAuth } from "domains/auth";
import { UserProfile, type UserProfileProps } from "domains/orgs/components/UserProfile";
import { useActiveLocation, useStoredLocationId } from "services/locationOrgContext";

interface UserProfileContainerProps extends Omit<UserProfileProps, "user" | "activeLocation" | "isDeepLink"> {}

export function UserProfileContainer({ className, size = "large", ...rest }: Readonly<UserProfileContainerProps>) {
  const { user } = useAuth();
  const [activeLocation] = useActiveLocation();
  const storedLocationId = useStoredLocationId();

  if (!activeLocation || !user) return null;

  const isDeepLink = storedLocationId !== undefined && storedLocationId !== activeLocation.id;

  return <UserProfile user={user} activeLocation={activeLocation} size={size} isDeepLink={isDeepLink} {...rest} />;
}
